import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';

/**
 * Component is used to show and hide content. Collapsing an element will
 * animate the height from it’s current value to 0. Given how CSS handles
 * animations max-height should be explicitly declared.
 */
var AccordionComponent = /** @class */ (function (_super) {
    __extends(AccordionComponent, _super);
    function AccordionComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        return _this;
    }
    AccordionComponent.prototype.toggle = function () {
        if (this.controlled) {
            return this.visible;
        }
        this.visible = !this.visible;
        return this.visible;
    };
    AccordionComponent.prototype.changeVisibility = function () {
        if (this.controlled) {
            this.visible = this.initiallyVisible;
            return;
        }
        if ((this.initiallyVisible && !this.visible) ||
            (!this.initiallyVisible && this.visible)) {
            this.toggle();
        }
    };
    Object.defineProperty(AccordionComponent.prototype, "elevationClass", {
        get: function () {
            if (this.elevation <= 0 || this.elevation > 5) {
                return '';
            }
            return "accordion--elevation-" + this.elevation;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "topNavVariant", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "initiallyVisible", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "noAnimation", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "wide", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "noOverflow", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "controlled", void 0);
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], AccordionComponent.prototype, "elevation", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], AccordionComponent.prototype, "hideAccordionToggle", void 0);
    __decorate([
        Emit('toggle'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AccordionComponent.prototype, "toggle", null);
    __decorate([
        Watch('initiallyVisible', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AccordionComponent.prototype, "changeVisibility", null);
    AccordionComponent = __decorate([
        Component({
            name: 'ui-accordion',
            inheritAttrs: false,
        })
    ], AccordionComponent);
    return AccordionComponent;
}(Mixins(MagicConfigMixin)));

export default AccordionComponent;
